var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[(_vm.$store.state.info.type !== 'GUEST')?_c('info',{attrs:{"data":_vm.$store.state.info.msg}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }